module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('base-modal', {
    staticClass: "modal-lg",
    attrs: {
      "modalTitle": 'Agent Detail',
      "loaded": _vm.loaded,
      "saveDisabled": !_vm.editable
    },
    on: {
      "save": function($event) {
        return _vm.save()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [
    [_c('div', {
      staticClass: "row"
    }, [_c('h1', [_vm._v(_vm._s(_vm.agent.npn) + " - " + _vm._s(_vm.agent.name))]), _vm._v(" "), (!_vm.editable) ? _c('div', {
      staticClass: "alert alert-warning"
    }, [_c('i', {
      staticClass: "fa fa-warning"
    }), _vm._v(" Agent's profile is linked to a 3rd party service and cannot be edited.")]) : _vm._e(), _vm._v(" "), _c('FormulateForm', {
      attrs: {
        "errors": _vm.fieldErrors
      }
    }, [_c('div', {
      staticClass: "col-xs-12 col-md-6"
    }, [_c('h2', [_vm._v("Contact Details")]), _vm._v(" "), _c('FormulateInput', {
      attrs: {
        "type": "text",
        "name": "npn",
        "label": "NPN",
        "validation": "required",
        "disabled": !_vm.editable
      },
      model: {
        value: (_vm.agent.npn),
        callback: function($$v) {
          _vm.$set(_vm.agent, "npn", $$v)
        },
        expression: "agent.npn"
      }
    }), _vm._v(" "), _c('FormulateInput', {
      attrs: {
        "type": "text",
        "name": "name",
        "label": "Name",
        "validation": "required",
        "disabled": !_vm.editable
      },
      model: {
        value: (_vm.agent.name),
        callback: function($$v) {
          _vm.$set(_vm.agent, "name", $$v)
        },
        expression: "agent.name"
      }
    }), _vm._v(" "), _c('FormulateInput', {
      attrs: {
        "type": "text",
        "name": "email",
        "label": "Email",
        "validation": "required",
        "disabled": !_vm.editable
      },
      model: {
        value: (_vm.agent.email),
        callback: function($$v) {
          _vm.$set(_vm.agent, "email", $$v)
        },
        expression: "agent.email"
      }
    }), _vm._v(" "), _c('FormulateInput', {
      attrs: {
        "type": "text",
        "name": "phone",
        "label": "Phone",
        "validation": "required",
        "disabled": !_vm.editable
      },
      model: {
        value: (_vm.agent.phone),
        callback: function($$v) {
          _vm.$set(_vm.agent, "phone", $$v)
        },
        expression: "agent.phone"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-6"
    }, [_c('h2', [_vm._v("Status: " + _vm._s(_vm._f("uppercase")(_vm.agent.status.code)))]), _vm._v(" "), _c('FormulateInput', {
      attrs: {
        "type": "checkbox",
        "label": "Active",
        "disabled": !_vm.editable
      },
      model: {
        value: (_vm.agent.is_active),
        callback: function($$v) {
          _vm.$set(_vm.agent, "is_active", $$v)
        },
        expression: "agent.is_active"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "input-group col-xs-12"
    }, [_c('div', [_c('b', [_vm._v("LeadScorz Id:")]), _vm._v(" " + _vm._s(_vm.agent.id) + " "), _c('a', {
      attrs: {
        "role": "button"
      },
      on: {
        "click": _vm.copyId
      }
    }, [_c('i', {
      staticClass: "fa fa-copy"
    })]), _vm._v(" "), (_vm.copiedId) ? _c('span', {
      staticClass: "copied-feedback"
    }) : _vm._e()])]), _vm._v(" "), (_vm.agent.appointments_profile.accept_appointments) ? [_c('h2', [_vm._v("Appointments Settings")]), _vm._v(" "), _c('h5', [_vm._v("Supported Appointment Types")]), _vm._v(" "), _vm._l((_vm.agent.appointments_profile.supported_appointment_types), function(appointment_type) {
      return _c('span', {
        staticClass: "label label-primary"
      }, [_vm._v(_vm._s(appointment_type))])
    }), _vm._v(" "), (_vm.agent.appointments_profile.daily_capacity != null) ? _c('h5', [_vm._v("Daily capacity: " + _vm._s(_vm.agent.appointments_profile.daily_capacity))]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("Tags")]), _vm._v(" "), _c('tags-widget', {
      attrs: {
        "tags": _vm.agent.tags,
        "readOnly": !_vm.editable
      },
      on: {
        "removeTag": _vm.removeTag,
        "addTag": _vm.addTag
      }
    })], 2)])], 1), _vm._v(" "), (_vm.agentId) ? _c('div', {
      staticClass: "row"
    }, [_c('h2', [_vm._v("License Status")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, _vm._l((_vm.agent.active_licenses), function(license) {
      return _c('div', {
        staticClass: "box col-xs-6"
      }, [_c('h4', [_vm._v(_vm._s(license.carrier) + " (" + _vm._s(license.year) + ")")]), _vm._v(" "), _vm._l((license.states), function(state) {
        return _c('span', {
          staticClass: "label label-default"
        }, [_vm._v(_vm._s(state))])
      })], 2)
    }), 0)]) : _vm._e(), _vm._v(" "), (_vm.agentId) ? _c('div', {
      staticClass: "row"
    }, [_c('h2', [_vm._v("Historical Performance")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "col-xs-3"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "panel stats"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_vm._v("\n                  Active Appointments\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "metrics-banner-text text-center"
    }, [_vm._v("\n                    " + _vm._s(_vm.agent.historical_performance.active_appointments) + "\n                  ")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "panel stats"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_vm._v("\n                  Pending Confirmation\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "metrics-banner-text text-center"
    }, [_vm._v("\n                    " + _vm._s(_vm.agent.historical_performance.pending_confirmation_appointments) + "\n                  ")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "panel stats"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_vm._v("\n                  Confirmation Rate\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "metrics-banner-text text-center"
    }, [_vm._v("\n                    " + _vm._s(_vm.agent.historical_performance.confirmation_rate) + "\n                  ")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "panel stats"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_vm._v("\n                  Completion Rate\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "metrics-banner-text text-center"
    }, [_vm._v("\n                    " + _vm._s(_vm.agent.historical_performance.completion_rate) + "\n                  ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.agentId) ? _c('div', {
      staticClass: "row"
    }, [_c('h2', [_vm._v("Appointments")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('table', {
      staticClass: "table table-condensed"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Id")]), _c('th', [_vm._v("Created At")]), _c('th', [_vm._v("Appointment Type")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Start At")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.agentAppointments), function(appointment) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(appointment.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatTimestamp")(appointment.created)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(appointment.appointment_type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(appointment.current_status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatTimestamp")(appointment.start_timestamp)))])])
    }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.agentId && _vm.agent.appointments_profile.consolidated_slots) ? _c('div', {
      staticClass: "row"
    }, [_c('h2', [_vm._v("Available Slots")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('table', {
      staticClass: "table table-condensed table-bordered table-hover"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Time")]), _vm._v(" "), _vm._l((_vm.agent.appointments_profile.consolidated_slots.header), function(day) {
      return _c('th', [_vm._v(_vm._s(day))])
    })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.agent.appointments_profile.consolidated_slots.rows), function(slots) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(slots['key']))]), _vm._v(" "), _vm._l((_vm.agent.appointments_profile.consolidated_slots.header), function(day) {
        return [(slots['days'][day]) ? _c('td', _vm._l((slots['days'][day]), function(appointmentType) {
          return _c('span', {
            staticClass: "label",
            class: _vm.getLabelColor(appointmentType)
          }, [_c('i', {
            staticClass: "fa fa-lg",
            class: _vm.getIcon(appointmentType),
            attrs: {
              "title": _vm.getAltText(appointmentType)
            }
          })])
        }), 0) : _c('td', [_c('span', [_vm._v("-")])])]
      })], 2)
    }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.agentId && _vm.agent.appointments_profile.regular_schedule) ? _c('div', {
      staticClass: "row"
    }, [_c('h2', [_vm._v("Regular Schedule")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('p', [_vm._v("\n            Timezone: " + _vm._s(_vm.agent.appointments_profile.timezone) + "\n           ")]), _vm._v(" "), _c('table', {
      staticClass: "table table-condensed table-hover"
    }, [_c('tbody', _vm._l((_vm.agent.appointments_profile.regular_schedule), function(weekday) {
      return _c('tr', [_c('th', [_vm._v(_vm._s(weekday.day))]), _vm._v(" "), _c('td', _vm._l((weekday.slots), function(types, slot) {
        return _c('span', {
          staticClass: "label label-default"
        }, [_vm._v("\n                   " + _vm._s(slot) + " "), _vm._l((types), function(type) {
          return _c('span', {
            staticClass: "label",
            class: _vm.getLabelColor(type)
          }, [_c('i', {
            staticClass: "fa fa-lg",
            class: _vm.getIcon(type),
            attrs: {
              "title": _vm.getAltText(type)
            }
          })])
        })], 2)
      }), 0)])
    }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.agentId) ? _c('div', {
      staticClass: "row"
    }, [_c('h2', [_vm._v("ZIP Codes definition")]), _vm._v(" "), _vm._l((_vm.agent.appointments_profile.travel_zipcodes), function(def_by_type) {
      return _c('div', {
        staticClass: "col-xs-12"
      }, [_c('h4', [_vm._v(_vm._s(def_by_type.label))]), _vm._v(" "), _c('table', {
        staticClass: "table table-condensed"
      }, [_c('thead', [_c('tr', [_c('th', [_vm._v("State")]), _c('th', [_vm._v("ZIP Codes")])])]), _vm._v(" "), _c('tbody', _vm._l((def_by_type.states), function(def_by_state) {
        return _c('tr', [_c('td', [_vm._v(_vm._s(def_by_state.state))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(def_by_state.zipcodes.length > 20 ? def_by_state.zipcodes.slice(0, 10).join(', ') + " ... (total: " + (def_by_state.zipcodes.length - 10).toString() + ")" : def_by_state.zipcodes.join(', ')))])])
      }), 0)])])
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('h4', [_vm._v("Check ZIP Code coverage")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4"
    }, [_c('FormulateForm', {
      on: {
        "submit": _vm.checkZipcode
      }
    }, [_c('div', {
      staticClass: "zipcode-check"
    }, [_c('FormulateInput', {
      attrs: {
        "type": "text",
        "placeholder": "Enter ZIP code"
      },
      model: {
        value: (_vm.zipcodeCheck),
        callback: function($$v) {
          _vm.zipcodeCheck = $$v
        },
        expression: "zipcodeCheck"
      }
    }), _vm._v(" "), _c('FormulateInput', {
      attrs: {
        "type": "submit",
        "label": "Check"
      }
    })], 1)])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8"
    }, [(_vm.zipcodeCheck && _vm.zipcodeCheckResult) ? _c('div', {
      staticClass: "well well-sm"
    }, [(_vm.zipcodeCheckResult.is_covered) ? _c('p', [_vm._v("Available Appointment Types in "), _c('b', [_vm._v(_vm._s(_vm.zipcodeCheckResult.zipcode))]), _vm._v(": "), _vm._l((_vm.zipcodeCheckResult.appointment_types), function(appointmentType) {
      return _c('span', {
        staticClass: "label label-primary"
      }, [_vm._v(_vm._s(appointmentType))])
    })], 2) : _c('p', [_c('b', [_vm._v(_vm._s(_vm.zipcodeCheckResult.zipcode))]), _vm._v(" is not covered")])]) : _vm._e()])])], 2) : _vm._e()]
  ], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8fc8809a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/AgentModal.vue
// module id = 674
// module chunks = 0